import { withHistory } from '@sama/rxjs-core';
import { Observable, of, timer } from 'rxjs';
import { delayWhen, map, timeInterval } from 'rxjs/operators';

export function isSavingWithMinimumDuration$(
  isSaving$: Observable<boolean>,
  duration: number,
) {
  return isSaving$.pipe(
    withHistory(1),
    timeInterval(),
    delayWhen((valueWithInterval) => {
      const [_, wasSaving] = valueWithInterval.value;

      // immediately display saving indicator when changing from not saving to
      // saving state
      if (!wasSaving) {
        return of(0);
      }

      const relativeDuration = Math.max(
        duration - valueWithInterval.interval,
        0,
      );
      return timer(relativeDuration);
    }),
    map((valueWithInterval) => valueWithInterval.value[0]),
  );
}
